import strip_tags from 'components/Dashboard/utilities/stripTags';

function splitByBrToParagraphs(content) {
  const parts = content.split('<br><br>');
  let result = '';
  for (let i = 0; i < parts.length; i++) {
    const part = parts[i].trim();
    if (!part || part === '') {
      continue;
    }
    const innerParts = part.split('<br>');
    let innerResult = '';
    for (let j = 0; j < innerParts.length; j++) {
      const innerPart = innerParts[j].trim();
      if (!innerPart || innerPart === '') {
        continue;
      }
      innerResult += innerParts.length > 1 ? `<p>${innerPart}</p>` : innerPart;
    }
    result += `<p>${innerResult}</p><br>`;
  }
  return result;
}

export default function pasteHandler(body) {
  let content = strip_tags(splitByBrToParagraphs(body), '<b><u><i><p><li><strong><a><br><ol><span><svg>').replace(
    /<p>\s*<\/p>/g,
    ''
  );
  const parser = new DOMParser();
  const document = parser.parseFromString(content, 'text/html');

  // Default styles
  const defaultStyles = {
    'font-family': "Arial, Helvetica, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
    'font-size': '15px',
    margin: '0',
    color: '#00122b',
  };

  // Helper to parse and merge styles
  function mergeStyles(existingStyle) {
    const styleObj = {};
    if (existingStyle) {
      existingStyle.split(';').forEach((rule) => {
        const [key, value] = rule.split(':').map((s) => s && s.trim());
        if (key && value) styleObj[key] = value;
      });
    }
    // Add defaults if missing
    Object.entries(defaultStyles).forEach(([key, value]) => {
      if (!styleObj[key]) styleObj[key] = value;
    });
    // Rebuild style string
    return Object.entries(styleObj)
      .map(([k, v]) => `${k}: ${v}`)
      .join('; ');
  }

  // Remove all empty <p> nodes and update styles
  document.querySelectorAll('p').forEach((p) => {
    // Remove if empty or only contains <br> (and possibly whitespace)
    if (
      !p.textContent.trim() &&
      (p.childNodes.length === 0 || (p.childNodes.length === 1 && p.childNodes[0].nodeName === 'BR'))
    ) {
      p.parentNode.removeChild(p);
    } else {
      // Merge or add styles
      p.setAttribute('style', mergeStyles(p.getAttribute('style')));
    }
  });
  return document.body?.innerHTML;
}
